import { render, staticRenderFns } from "./report-comp.vue?vue&type=template&id=ed5389c8&"
import script from "./report-comp.vue?vue&type=script&lang=js&"
export * from "./report-comp.vue?vue&type=script&lang=js&"
import style0 from "./report-comp.vue?vue&type=style&index=0&id=ed5389c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports